module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YIN2de/tc-custom/9781504080040.jpg?1738495253955",
      "alt": "This image is the cover for the book Human Assets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Human Assets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“I am a huge fan . . . this book deserves 10 stars. Fast-paced and action-packed . . . Brilliant!” —Rock Chick Fee, five stars"), _c('br'), _c('br'), _c('b', [_vm._v("After her son’s tragic death, a former cop discovers his dangerous secret life—and picks up where he left off . . .")]), _c('br'), _c('br'), _vm._v(" Former police officer Emma Raven has a heartbreaking task ahead of her: gathering her late son’s possessions from his Cambridge college."), _c('br'), _c('br'), _vm._v(" His death was deemed a suicide. But once she enters Paul’s room accompanied by his director of studies, Colin Gormley, and finds it’s been ransacked, she’s troubled. When this is followed by attacks against both Emma and Colin, the two flee."), _c('br'), _c('br'), _vm._v(" But the danger doesn’t stop there."), _c('br'), _c('br'), _vm._v(" Before long, the grieving mother is entangled in a deadly mystery that puts her right in the line of fire . . .")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alex Walters\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0